//入力情報確認
import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ResponseParam } from "./Confirm";
import { TitleParamContext } from '../../context/TitleContext';
import market from "../../css/market.module.scss";
import base from "../../css/market.module.css";
import confirm from "../../css/confirm.module.css";


export const Complete = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const stateValue = location.state as ResponseParam;
    const [resultMessage, setResultMessage] = useState<ResponseParam>(stateValue);
    const titleConext = useContext(TitleParamContext);
    //const message: string = "";


    useEffect(() => {
        titleConext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "サポート会員情報", secondSubTitle: "（仮登録）" });
    }, []);

    return (
        <>
            <section className={confirm.OutSideArea}>
                <div className={confirm.InSideArea}>
                    <h2>下記宛先に、本登録確認メールを送付しました。</h2>
                    <h3>{resultMessage.message}</h3>                    
                    <h4>サポート会員登録は、まだ完了しておりません。</h4>
                    24時間以内にメール内に記載の《本登録URL》にアクセスし<br/>
                    パスワードを入力することで、本登録（サポート会員登録の完了）となります。
                </div>
            </section>
        </>
    );
}